import type { MENU_TYPE } from '../entities/MenuType'
import type { AuthUserType } from '~/modules/auth/entities/AuthUser'

export const contentCall = async (
  menu_type: MENU_TYPE,
  user_type: AuthUserType = false,
) => {
  const userUrl = user_type !== false ? `-${user_type}` : ''

  const contentConstant = await import(`../constants/${menu_type}${userUrl}.ts`)

  // @ts-ignore
  const contentQueryContent = contentConstant.default

  return contentQueryContent
}
